import { Reveal } from "./Reveal";

const STATS = [
  { value: "4.2×", label: "Avg. ROI on deployed AI systems" },
  { value: "38%", label: "Median reduction in operating cost" },
  { value: "11 wks", label: "From diagnostic to first outcome" },
];

const Intro = () => (
  <section id="intro" data-testid="intro-section" className="bg-white px-6 py-28 lg:px-12 lg:py-40">
    <div className="mx-auto max-w-[1500px]">
      <Reveal>
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-cobalt">
          / The Prospera thesis
        </span>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 gap-16 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl font-medium leading-[1.15] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Most firms hand you a slide deck. We hand you a system that runs —
              <span className="text-cobalt"> optimizing your business long after the engagement ends.</span>
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-4 lg:pt-4">
          <Reveal delay={0.15}>
            <p className="text-base font-light leading-relaxed text-ink/60">
              We sit at the intersection of strategy and engineering. Every
              recommendation is backed by working AI infrastructure — models,
              automations and decision systems designed to compound value
              across your organization.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mt-24 grid grid-cols-1 gap-px border-t border-black/10 sm:grid-cols-3">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div className="border-b border-black/10 py-10 sm:border-b-0 sm:border-r sm:pr-8 sm:last:border-r-0">
              <div className="font-serif text-6xl font-medium tracking-tight text-cobalt-dark lg:text-7xl">
                {s.value}
              </div>
              <div className="mt-4 max-w-[220px] font-mono text-xs uppercase leading-relaxed tracking-[0.12em] text-ink/50">
                {s.label}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Intro;
